import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "flex-wrap-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "color(display-p3 0.000 0.000 0.000)", strokeLinecap: "round" },
        React.createElement("path", { strokeLinejoin: "round", d: "M5.5 8 3 10.5 5.5 13" }),
        React.createElement("path", { d: "M8.5 4.5h2.75A2.75 2.75 0 0 1 14 7.25v.25a3 3 0 0 1-3 3H3h0" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
